import styled from 'styled-components'
import type { SelectProps } from '@/components_deprecated';
import { Select } from '@/components_deprecated'

const StyledWrapper = styled.div`
  .--select-display-selected {
    padding: 0.6rem 0.8rem;
    font-size: 1.2rem !important;
    font-weight: 500;
    color: ${props => props.theme.colors.white};
    border-radius: 16px;
    background: ${props => props.theme.colors.primary};
  }

  .--select-display-selected-clear {
    background: none;
  }

  .--select-display-selected > div > i {
    color: ${props => props.theme.colors.white};
  }
`

export const LeaderGroupSelect = <
  ValueType extends string | number,
  ExtraType = any,
>(
  props: SelectProps<ValueType, ExtraType>
) => {
  return (
    <StyledWrapper>
      <Select {...props} />
    </StyledWrapper>
  )
}
